import type {CalculationRequest} from './types.ts';

export const bimCadTemplateIds = ['78000000-0000-4000-8000-000000000001', '65000000-0000-4000-8000-000000000001'];
export const supportsBimCad = (id:string) => bimCadTemplateIds.includes(id);

// CAD receives geometry only. Pricing, stock selections and workshop inputs
// stay in the existing calculation request and cannot be overwritten by CAD.
export function bimCadRequest(request:CalculationRequest) {
 if(!supportsBimCad(request.templateId))return null;
 const columns=request.sections.map(s=>s.widthMm), rows=request.rowHeightsMm;
 const allowed=['Fixed','TurnLeft','TurnRight','Tilt','TiltTurnLeft','TiltTurnRight'];
 if(![request.widthMm,request.heightMm].every(x=>Number.isFinite(x)&&x>=400&&x<=6000)
   ||columns.length<1||columns.length>7||rows.length<1||rows.length>4||rows.length!==request.rowCount
   ||![...columns,...rows].every(x=>Number.isFinite(x)&&x>=200)
   ||Math.abs(columns.reduce((a,b)=>a+b,0)-request.widthMm)>.001
   ||Math.abs(rows.reduce((a,b)=>a+b,0)-request.heightMm)>.001
   ||request.cellOpenings.length!==columns.length*rows.length||request.cellOpenings.some(o=>!allowed.includes(o)))return null;
 return {templateId:request.templateId,widthMm:request.widthMm,heightMm:request.heightMm,
  columnWidthsMm:[...columns],rowHeightsMm:[...rows],openings:[...request.cellOpenings]};
}
